import type { ExternalContextTypeAttachment } from './ExternalContextTypeAttachment';
import type { FileTypeAttachment } from './FileTypeAttachment';


/**
 * Cleanup blob URLs for file attachments to prevent memory leaks.
 */
export const cleanupBlobUrls = (
	attachments: (FileTypeAttachment | ExternalContextTypeAttachment)[],
): void => {
	attachments.forEach((attachment) => {
		if (attachment.type === 'file' && attachment.data.previewBlobUrl) {
			URL.revokeObjectURL(attachment.data.previewBlobUrl);
		}
	});
};
